import React from 'react';
import PropTypes from 'prop-types';

import { CarouselStyled } from './Carousel.styled';

const Carousel = React.forwardRef((props, ref) => {
  const settings = {
    accessibility: true,
    arrows: false,
    dots: props.dots || true,
    easing: 'fadeinout',
    infinite: false,
    initialSlide: props.initialSlide || 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    useCSS: true,
    adaptiveHeight: true,
  };

  return <CarouselStyled ref={ref} {...settings} {...props} />;
});

Carousel.propTypes = {
  children: PropTypes.node,
  useCustomArrows: PropTypes.bool,
};

Carousel.defaultProps = {
  children: '',
  useCustomArrows: false,
};

export default Carousel;
